<template>
    <v-form
            ref="modifyStatusForm"
            @submit.prevent=""
            class="fill-height of-y"
            :disabled="loading"
    >
        <div class="of-y">
            <div class="d-flex align-center primary pl-3 pr-2">
                <div class="flex-grow-1 sub--text">
                    {{empStatus.id ? 'Edit Employee Status' : 'Create Employee Status'}}
                </div>
                <div v-if="!empStatus.id">
                    <v-btn
                            icon
                            color="white"
                            small
                            @click="$emit('dismiss')"
                    >
                        <v-icon small>mdi-close</v-icon>
                    </v-btn>
                </div>
            </div>
            <v-divider></v-divider>
            <div class="pb-1">
                <div class="flex-grow-1 of-y px-2 pb-1">
                    <v-text-field
                            label="Status Name"
                            hide-details="auto"
                            v-model="empStatus.name"
                            @input="changesMade = true"
                            :rules="[validationRules.required, validationRules.notNull, duplicateEmpStatusName]"
                            :error-messages="empStatusNameErrorMessages"
                    />
                </div>

                <div class="flex-grow-1 of-y px-2 pb-1">
                    <v-autocomplete
                        label="Restricted Actions"
                        hide-details="auto"
                        v-model="empStatus.restrictedActions"
                        @input="changesMade = true"
                        :items="restrictedActionsList"
                        item-value="id"
                        item-text="text"
                        multiple
                        chips
                        small-chips
                        deletable-chips
                    />
                </div>


                <div class="text-right pr-2 pb-1 pt-2">
                    <v-btn
                            @click="validateSave()"
                            fab
                            small
                            color="secondary"
                            :loading="loading"
                            :disabled="!changesMade || loading"
                    >
                        <v-icon v-if="!loading">mdi-content-save</v-icon>
                    </v-btn>
                </div>


            </div>
        </div>

    </v-form>
</template>

<script>
import {mapGetters} from 'vuex'
import {arrSplice, generateRandomId, validationRules} from "@/core/codeFunctions";
import MultiSelectList from "@/components/General/Multi Select List/MultiSelectList";
import {newReqUpload} from "@/core/request";
import {EmpStatus} from "@/core/store";

export default {
    components: { MultiSelectList},
    props: {
        editStatus: EmpStatus
    },
    data() {
        return {
            loading: false,
            validationRules: validationRules,
            changesMade: false,
            arrSplice,
            empStatus: new EmpStatus(),
            empStatusNameErrorMessages: null,

        }
    },
    watch: {
        editStatus: {
            deep: true,
            immediate: true,
            handler(val) {
                this.changesMade = false
                this.viewValue = true
                this.empStatus = new EmpStatus(JSON.parse(JSON.stringify(val || null)))
            }
        },
    },
    methods: {

        duplicateEmpStatusName(val) {
            if (!val) {
                return "A name is required"
            }
            if (this.empStatuses.find(status => status.id !== this.empStatus.id && (this.empStatus.name || '').toLowerCase() === (status.name || '').toLowerCase())) {
                return "Duplicate employee status name"
            }
            return true
        },

        async validateSave() {

            if (!this.$refs.modifyStatusForm.validate())
                return false


            this.$emit('save', {empStatus: this.empStatus, ref: this})
        }
    },
    computed: {
        ...mapGetters(['empStatuses', 'farms', "restrictedActionsList"])
    },
}
</script>

<style scoped>

</style>